import { TagType } from "./tag";

export const emptyTagRepresentation = {
    id: "876544",
    name: "",
    type: TagType.Workstream
}